import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-project-stats-table',
  templateUrl: './project-stats-table.component.html',
  styleUrls: ['project-stats-table.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectStatsTableComponent {}
